import {Component, Vue} from 'vue-property-decorator';
import StringUtils from '@/utils/StringUtils';
import MessageUtils from '@/utils/MessageUtils';
import AppSession from '@/store/AppSession';
import ApiUtils from '@/utils/ApiUtils';

/**
 * 모든 Component에서 사용 가능한 mixin
 *
 * hook 관련 처리가 없는 순수 mixin
 *
 * loading 및 Util 인스턴스가 존재한다.
 */
@Component
export default class DefaultComponentMixin extends Vue {
    protected readonly editPrivId: string = '';
    
    public componentInitialized: boolean = false;
    protected loading: boolean = true;
    protected StringUtils = StringUtils;
    
    get isComponentReady() {
        return !this.componentInitialized;
    }
    
    get isLoading() {
        return this.loading;
    }
    
    get hasEditPrivilege() {
        return this.$store.getters.privilegeMap[this.editPrivId] || this.isAdmin;
    }
    
    get hasPrivilege() {
        return (privId: string) => this.$store.getters.privilegeMap[privId] || this.isAdmin;
    }
    
    get workflowVisibile() {
        return this.hasPrivilege('READ.CASE_WORKFLOW') && this.$store.getters.isUseWorkflow;
    }
    
    get useWorkflow() {
        return this.$store.getters.isUseWorkflow;
    }

    get isAdmin() {
        return this.$route.meta.isAdmin;
    }

    /**
     * Case > NR > H.1 AI Coding 시작으로 인한 전체 컴포넌트 컨트롤
     */
    get isProgressCaseNRAiCoding() {
        return this.$store.getters.isProgressCaseNRAiCoding;
    }
    
    protected afterRequestFail(message: string) {
        const obj = {
            userId: this.$store.getters.userId,
            userKey: this.$store.getters.userKey,
            token: AppSession.getAccessToken(),
            message,
            route: {
                fullPath: this.$route.fullPath,
                path: this.$route.path,
                name: this.$route.name,
                params: this.$route.params,
                query: this.$route.query
            },
            additional: {
                message,
                category: 'RETRIEVE_FAIL'
            }
        };
        ApiUtils.reportError('RETRIEVE_FAIL', obj);
        MessageUtils.displayErrorMessage(message);
    }
    
    /**
     * ICH
     * EU
     * KR
     * CN
     * JP
     * @param appendix
     */
    protected matchAppendix(appendix: string): boolean {
        return this.$route.params.appendix === appendix;
    }
}
